export function routeNeedsCollectionPolling(state, route, options = {}) {
  if (!route || !route.id) {
    return false;
  }
  if (route.id === "threads" || route.id === "turns") {
    return options.hasActiveWork?.() || false;
  }
  if (route.id === "models") {
    return Boolean(state.inferenceEnabled);
  }
  if (route.id === "thread-detail") {
    return threadNeedsCollectionPolling(state.threadDetail.thread);
  }
  return false;
}

export function threadNeedsCollectionPolling(threadItem) {
  if (!threadItem) {
    return false;
  }
  const threadState = String(threadItem.state || "").trim().toLowerCase();
  if (threadState === "awaiting_remote_merge") {
    return true;
  }
  const latest = threadItem.latest_promotion || null;
  return latest?.mode === "remote_pr" && latest?.state === "running";
}
